// extracted by mini-css-extract-plugin
export default {"link":"BcqsD","is-disabled":"hhmae","is-inherit":"usxsx","is-inverse":"E4LCd"};